import React from 'react';
import { Rocket, RefreshCw, ShieldCheck } from 'lucide-react';
export function ProductTransformation() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-127">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="text-center mb-12" data-id="element-129">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary mb-4" data-id="element-130">
            ¿Qué vas a lograr en estos 14 días?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-131">
            Un protocolo práctico para apagar la ansiedad, recuperar energía y
            deshincharte sin vivir a dieta.
          </p>
        </div>

        {/* The Triad Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-132">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-1 bg-gray-100 -z-10 transform translate-y-4" data-id="element-133"></div>

          {/* Phase 1 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all hover:-translate-y-1 relative group" data-id="element-134">
            <div className="flex items-center gap-3 mb-6" data-id="element-135">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors" data-id="element-136">
                <Rocket className="h-6 w-6" data-id="element-137" />
              </div>
              <div className="px-3 py-1 bg-gray-100 text-gray-600 text-xs font-bold rounded-full" data-id="element-138">
                DÍAS 1-3
              </div>
            </div>

            <h3 className="text-2xl font-bold text-secondary mb-2" data-id="element-139">
              FASE 1: El Despegue
            </h3>
            <p className="text-primary font-medium mb-4 italic" data-id="element-140">
              "Corta el cable que te une a la ansiedad."
            </p>
            <p className="text-gray-600 mb-6 text-sm" data-id="element-141">
              Es la fase más importante. Aquí es donde "limpiamos" tu sistema.
            </p>
            <ul className="space-y-3 text-sm text-gray-700" data-id="element-142">
              <li className="flex gap-2" data-id="element-143">
                <span className="font-bold text-secondary" data-id="element-144">
                  Adiós al ruido mental:
                </span>
                <span data-id="element-145">
                  En 72h bajamos la inflamación y silenciamos esa voz.
                </span>
              </li>
              <li className="flex gap-2" data-id="element-146">
                <span className="font-bold text-secondary" data-id="element-147">
                  Kit de Emergencia:
                </span>
                <span data-id="element-148">Usa el "Elixir de Hidratación" para evitar mareos.</span>
              </li>
            </ul>
          </div>

          {/* Phase 2 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all hover:-translate-y-1 relative group" data-id="element-149">
            <div className="flex items-center gap-3 mb-6" data-id="element-150">
              <div className="w-12 h-12 bg-accent-coral/10 rounded-xl flex items-center justify-center text-accent-coral group-hover:bg-accent-coral group-hover:text-white transition-colors" data-id="element-151">
                <RefreshCw className="h-6 w-6" data-id="element-152" />
              </div>
              <div className="px-3 py-1 bg-gray-100 text-gray-600 text-xs font-bold rounded-full" data-id="element-153">
                DÍAS 4-10
              </div>
            </div>

            <h3 className="text-2xl font-bold text-secondary mb-2" data-id="element-154">
              FASE 2: Re-calibración
            </h3>
            <p className="text-accent-coral font-medium mb-4 italic" data-id="element-155">
              "Tu cuerpo aprende a usar su propia grasa."
            </p>
            <p className="text-gray-600 mb-6 text-sm" data-id="element-156">
              Aquí ocurre la magia metabólica. Dejas de depender de comida
              externa.
            </p>
            <ul className="space-y-3 text-sm text-gray-700" data-id="element-157">
              <li className="flex gap-2" data-id="element-158">
                <span className="font-bold text-secondary" data-id="element-159">Poder Real:</span>
                <span data-id="element-160">Energía constante sin picos ni bajones de tarde.</span>
              </li>
              <li className="flex gap-2" data-id="element-161">
                <span className="font-bold text-secondary" data-id="element-162">Paladar Nuevo:</span>
                <span data-id="element-163">
                  La comida real te sabe increíble, el azúcar empalaga.
                </span>
              </li>
            </ul>
          </div>

          {/* Phase 3 */}
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all hover:-translate-y-1 relative group" data-id="element-164">
            <div className="flex items-center gap-3 mb-6" data-id="element-165">
              <div className="w-12 h-12 bg-accent-gold/10 rounded-xl flex items-center justify-center text-accent-gold group-hover:bg-accent-gold group-hover:text-white transition-colors" data-id="element-166">
                <ShieldCheck className="h-6 w-6" data-id="element-167" />
              </div>
              <div className="px-3 py-1 bg-gray-100 text-gray-600 text-xs font-bold rounded-full" data-id="element-168">
                DÍAS 11-14
              </div>
            </div>

            <h3 className="text-2xl font-bold text-secondary mb-2" data-id="element-169">
              FASE 3: Estabilización
            </h3>
            <p className="text-accent-gold font-medium mb-4 italic" data-id="element-170">
              "Conviértete en la dueña de tus decisiones."
            </p>
            <p className="text-gray-600 mb-6 text-sm" data-id="element-171">
              Ya no eres esclava de un impulso; ahora tú decides.
            </p>
            <ul className="space-y-3 text-sm text-gray-700" data-id="element-172">
              <li className="flex gap-2" data-id="element-173">
                <span className="font-bold text-secondary" data-id="element-174">
                  Blindaje Social:
                </span>
                <span data-id="element-175">Maneja el "corrientazo" y fiestas sin retroceder.</span>
              </li>
              <li className="flex gap-2" data-id="element-176">
                <span className="font-bold text-secondary" data-id="element-177">
                  Libertad Total:
                </span>
                <span data-id="element-178">Sales con un cuerpo que ya no "necesita" azúcar.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}